import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import { Link, Typography } from '@mui/material';

import { Icon } from '../../components/common';
import { useDocumentIcon } from '../../hooks/useIcons';
import { GET_CUSTOMER } from '../../shared';

import CustomerDetailsEditFormWrapper from '../contractManagement/CustomerDetails/CustomerDetailsEditFormWrapper';
import BankDetailsEditor from '../contractManagement/CustomerDetails/BankDetailsEditor';

import {
  StyledMissingIbanBannerContainer,
  StyledMissingIbanBannerBody,
  StyledMissingIbanBannerText,
  StyledDissmissButton,
  StyledMissingIbanBannerIcon,
} from './MissingIBANCard.styled';

const renderLink = (chunk, onClick) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <Link component="button" variant="p" onClick={onClick}>
    {chunk}
  </Link>
);

export default function MissingIBANCard(props) {
  const { onDismiss } = props;

  const intl = useIntl();

  const { data: customerData } = useQuery(GET_CUSTOMER);
  const { digitalPaymentMethod, customer } = customerData || {};
  const {
    bankAccountFirstName,
    bankAccountLastName,
    iban,
    contract: { billingDay } = {},
  } = customer || {};

  const { active: hasActiveDigitalPaymentMethod } = digitalPaymentMethod || {};

  const [showBankDetailsEditor, setShowBankDetailsEditor] = useState(false);

  const documentIcon = useDocumentIcon();

  return (
    <>
      <StyledMissingIbanBannerContainer dismissable={Boolean(onDismiss)}>
        <StyledMissingIbanBannerBody dismissable={Boolean(onDismiss)}>
          <StyledMissingIbanBannerIcon icon={documentIcon} />

          <div>
            <Typography variant="h3">
              <FormattedMessage id="policy.info.missing.iban.title" />
            </Typography>

            <StyledMissingIbanBannerText dismissable={Boolean(onDismiss)}>
              <Typography variant="p">
                <FormattedMessage
                  id="policy.info.missing.iban.message"
                  values={{
                    a: (chunk) => renderLink(chunk, () => setShowBankDetailsEditor(true)),
                  }}
                />
              </Typography>
            </StyledMissingIbanBannerText>
          </div>
        </StyledMissingIbanBannerBody>

        {onDismiss && (
          <StyledDissmissButton type="button" onClick={onDismiss}>
            <Icon icon="icon.x" alt="Dismiss button" />
          </StyledDissmissButton>
        )}
      </StyledMissingIbanBannerContainer>

      <CustomerDetailsEditFormWrapper
        isOpen={showBankDetailsEditor}
        title={intl.formatMessage({ id: 'bank.details.add.missed.iban.modal.title' })}
        missingIban
        hasActiveDigitalPaymentMethod={hasActiveDigitalPaymentMethod}
        onClose={() => setShowBankDetailsEditor(false)}
        data={{
          firstName: bankAccountFirstName,
          lastName: bankAccountLastName,
          iban,
          billingDay,
        }}
        formComponent={<BankDetailsEditor />}
      />
    </>
  );
}
